import React from 'react'
import styles from './styles'
import { cx } from '@emotion/css'
import PropTypes from 'prop-types'
import { useAnalytics } from 'clientHelpers/context/analyticsContext'

const GetStartedModal = ({ handleClose }) => {
  const { addTrackingForCTA } = useAnalytics()

  const renderCloseModalButton = (
    <button onClick={() => handleClose()} className={styles.closeButton} aria-label="Close modal">
      <img src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/close_arrow.svg`} />
    </button>
  )

  return (
    <div className={styles.wrapper}>
      <div className={styles.leftDiv}>
        {renderCloseModalButton}
        <h3 className={cx(styles.heading, styles.centeredHeading)}>Get started with OfferZen</h3>
        <div className={styles.lineItem}>
          <img className={styles.check} src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/pricing_section/check.png`} alt="Check" />
          <p>
            Make <strong>unlimited hires</strong> and save up to 50% compared to traditional recruitment costs.
          </p>
        </div>
        <div className={styles.lineItem}>
          <img className={styles.check} src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/pricing_section/check.png`} alt="Check" />
          <p>
            Hire at a <strong>predictable cost</strong> with OfferZen’s custom annual plan.
          </p>
        </div>
        <div className={styles.lineItem}>
          <img className={styles.check} src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/pricing_section/check.png`} alt="Check" />
          <p>
            Access <strong>200+ new job-seeking developers</strong> every Monday.
          </p>
        </div>
        <div className={styles.lineItem}>
          <img className={styles.check} src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/pricing_section/check.png`} alt="Check" />
          <p>
            Guarantee your success with a free <strong>dedicated hiring success manager.</strong>
          </p>
        </div>

        <div className={styles.ctaContainer}>
          <a
            {...addTrackingForCTA({
              action: 'clicked get access',
              sourceDetail: 'get started modal',
              url: '/hire/get-started?marketplace_preview_lead=true',
            })}
            className={cx(styles.ctaButton, styles.signupButton)}>
            Get access to developers
          </a>
          <a
            {...addTrackingForCTA({
              action: 'Clicked book a demo',
              sourceDetail: 'get started modal',
              url: '/hire/book-call?marketplace_preview_lead=true',
            })}
            className={cx(styles.ctaButton, styles.bookDemoButton)}>
            Book a demo
          </a>
          <div className={styles.loginFooterText}>
            Already have an account? <a href="/users/sign_in">Log in</a>
          </div>
        </div>
      </div>
    </div>
  )
}

GetStartedModal.propTypes = {
  handleClose: PropTypes.func,
}

export default GetStartedModal
